export default "__VITE_ASSET__C70S5esc__"